import type { AIModel } from '../../api/structs/model';
import { AGENT_PROVIDERS, missingAgentCapabilities } from '../pipeline/agentModelCapability';

/**
 * The chat models an agent can work on: they call tools and read images (an
 * agent looks at the pictures it orders), and they are served by a provider the
 * engine runs agents on. The source is `ModelsAPI.getChatModels()`; the server
 * checks a saved choice again, so this only keeps the list honest. The rules are
 * the pipeline editor's (`agentModelCapability`), so both screens agree.
 */
export const agentModelOptions = (models: AIModel[]): AIModel[] =>
  models.filter(
    (model) =>
      model.type === 'chat' &&
      AGENT_PROVIDERS.includes(model.provider) &&
      missingAgentCapabilities(model, { tools: true, vision: true }).length === 0
  );
